export const initBalance = () => {
  return {
    type: "INIT_BALANCE"
  };
};

export const setBalanceOrganization = organization => ({
  type: "SET_BALANCE_ORGANIZATION",
  organization
});

export const setAccountingDates = accountingDates => ({
  type: "SET_BALANCE_ACCOUNTING_DATES",
  accountingDates
});

export const setStartDate = startDate => ({
  type: "SET_BALANCE_START_DATE",
  startDate
});

export const saveAccountingDates = resp => ({
  type: "SAVE_ACCOUNTING_DATES",
  payload: resp
});

export const setBalanceAttachment = balanceAttachment => ({
  type: "SET_BALANCE_ATTACHMENT",
  balanceAttachment
});

export const setAnnexeAttachment = annexeAttachment => ({
  type: "SET_ANNEXE_ATTACHMENT",
  annexeAttachment
});

export const setSourceModel = sourceModel => ({
  type: "SET_BALANCE_SOURCE_MODEL",
  sourceModel
});

export const setModelConfig = modelConfig => ({
  type: "SET_BALANCE_MODEL_CONFIG",
  modelConfig
});

export const setMultipleModelConfig = multipleModelConfig => ({
  type: "SET_BALANCE_MULTIPLE_MODEL_CONFIG",
  multipleModelConfig
});

export const saveBalance = resp => ({
  type: "SAVE_BALANCE",
  payload: resp
});

export const selectAnnexeCategory = category => ({
  type: "SELECT_ANNEXE_CATEGORY",
  category
});

export const selectAnnexeYear = year => ({
  type: "SELECT_ANNEXE_YEAR",
  year
});

export const saveAnnexes = resp => ({
  type: "SAVE_ANNEXES",
  payload: resp
});

export const selectFirstMonth = month => ({
  type: "SELECT_FIRST_MONTH",
  month
});

export const selectLastMonth = month => ({
  type: "SELECT_LAST_MONTH",
  month
});

export const selectTrimester = trimester => ({
  type: "SELECT_TRIMESTER",
  trimester
});

export const selectOneMonth = month => ({
  type: "SELECT_ONE_MONTH",
  month
});

export const selectFirstTrimester = trimester => ({
  type: "SELECT_FIRST_TRIMESTER",
  trimester
});
export const selectLastTrimester = trimester => ({
  type: "SELECT_LAST_TRIMESTER",
  trimester
});



// WEBPACK FOOTER //
// ./src/actions/actions/balance.js